export default {
  path: "*",
  component: resolve => require(["@/views/not-found"], resolve)
};
